import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA2ENBTntqPpUFn3dfsr-GGzw7NpkmFnAI",
  authDomain: "apply-edge-249ce.firebaseapp.com",
  projectId: "apply-edge-249ce",
  storageBucket: "apply-edge-249ce.firebasestorage.app",
  messagingSenderId: "79937336162",
  appId: "1:79937336162:web:6301ac0f2f8ba68d4ff23b",
  measurementId: "G-PWJZCKJZLL"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const analytics = getAnalytics(app);